import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Login from './pages/Auth/Login';
import Lock from './pages/Auth/Lock';

import Profile from './pages/Profile';
import Dashboard from './pages/Dashboard';

import NoPage from './pages/NoPage';

import Layout from './layouts/Layout';
import LoginLayout from './layouts/LoginLayout';

import ROUTES from './routes';
import PublicRoute from './PublicRoute';
import ProtectedRoute from './ProtectedRoute';

import ForgotPwd from './pages/Auth/ForgotPwd';
import ResetPwd from './pages/Auth/ResetPwd';
import EmailVerify from './pages/EmailVerify';

import Projects from './pages/Projects/Projects';
import AddProject from './pages/Projects/AddProject';
import EditProject from './pages/Projects/EditProject';

import SpaceCard from './pages/SpaceCard/SpaceCard';
import AddSpaceCard from './pages/SpaceCard/AddSpaceCard';
import EditSpaceCard from './pages/SpaceCard/EditSpaceCard';

import Seo from './pages/Seo/Seo';
import AddSeo from './pages/Seo/AddSeo';
import EditSeo from './pages/Seo/EditSeo';

import CMSWrapper from './pages/CMS/CMSWrapper';
import CTAList from './pages/CTA/CTAList';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* Public Routes */}
        <Route path={ROUTES.AUTH} element={<LoginLayout />}>
          <Route
            path={ROUTES.LOGIN}
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />
          <Route path={ROUTES.LOCK} element={<Lock />} />
          <Route path={ROUTES.FORGOTPWD} element={<ForgotPwd />} />
          <Route path={ROUTES.RESETPWD} element={<ResetPwd />} />
        </Route>

        {/* Protected Routes */}
        <Route
          path={ROUTES.ROOT}
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path={ROUTES.PROFILE} element={<Profile />} />

          <Route path={ROUTES.PROJECTS} element={<Projects />} />
          <Route path={ROUTES.ADD_PROJECT} element={<AddProject />} />
          <Route path={ROUTES.EDIT_PROJECT} element={<EditProject />} />

          <Route path={ROUTES.SPACECARDS} element={<SpaceCard />} />
          <Route path={ROUTES.ADD_SPACECARD} element={<AddSpaceCard />} />
          <Route path={ROUTES.EDIT_SPACECARD} element={<EditSpaceCard />} />

          <Route path={ROUTES.SEO} element={<Seo />} />
          <Route path={ROUTES.ADD_SEO} element={<AddSeo />} />
          <Route path={ROUTES.EDIT_SEO} element={<EditSeo />} />

          <Route path={ROUTES.CMS} element={<CMSWrapper />} />
          <Route path={ROUTES.CTA_CONTACT_US} element={<CTAList />} />
          <Route path={ROUTES.CTA_CAREER} element={<CTAList />} />
          <Route path={ROUTES.VERIFY_EMAIL} element={<EmailVerify />} />
        </Route>

        {/* 404 */}
        <Route path="*" element={<NoPage />} />
      </Routes>
    </BrowserRouter>
  );
}
